import { computed, Injectable, signal } from '@angular/core';

export type EntityBoardDensity = 'regular' | 'compact' | 'narrow';

export const ENTITY_BOARD_COMPACT_MAX_WIDTH = 960;
export const ENTITY_BOARD_NARROW_MAX_WIDTH = 480;
export type EntityBoardListTitleLines = 1 | 2 | 3;

export function resolveEntityBoardDensity(width: number, forceCompact = false): EntityBoardDensity {

  if (width <= ENTITY_BOARD_NARROW_MAX_WIDTH) return 'narrow';
  if (forceCompact || width <= ENTITY_BOARD_COMPACT_MAX_WIDTH) return 'compact';
  return 'regular';
}

export function normalizeEntityBoardListTitleLines(value: unknown): EntityBoardListTitleLines {

  const lines = Number(value);
  if (lines === 2 || lines === 3) return lines;
  return 1;
}

export function entityBoardListRowHeight(density: EntityBoardDensity, group: boolean, hasMetadata = true, titleLines: EntityBoardListTitleLines = 1): number {

  if (group || density === 'regular') return 40;
  const baseHeight = hasMetadata
    ? (density === 'narrow' ? 72 : 64)
    : 40;
  return baseHeight + ((titleLines - 1) * 20);
}

@Injectable()
export class EntityBoardDensityState {

  private readonly $width = signal(Number.POSITIVE_INFINITY);
  private readonly $forceCompact = signal(false);

  public readonly $density = computed(() => resolveEntityBoardDensity(this.$width(), this.$forceCompact()));
  public readonly $compact = computed(() => this.$density() !== 'regular');
  public readonly $narrow = computed(() => this.$density() === 'narrow');

  public setWidth(width: number): void {

    if (!Number.isFinite(width) || width <= 0 || this.$width() === width) return;
    this.$width.set(width);
  }

  public setForceCompact(forceCompact: boolean): void {

    this.$forceCompact.set(forceCompact);
  }
}
